import clsx from 'clsx';
import { Info } from 'lucide-react';
import type { ReactNode } from 'react';
import MutedText from 'components/common/MutedText';
import HubertLabel from 'components/HubertUI/HubertLabel';
import HubertTooltip from 'components/HubertUI/HubertTooltip';

/** Hover badge for fields whose effect isn't obvious from the label alone. */
export const FieldInfo = ({ children }: { children: ReactNode }) => (
  <HubertTooltip>
    <HubertTooltip.Trigger asChild>
      <Info size={13} className="cursor-help text-gray-400 hover:text-gray-600" />
    </HubertTooltip.Trigger>
    <HubertTooltip.Content portalContent={true}>
      <div className="w-64 leading-relaxed whitespace-normal">{children}</div>
    </HubertTooltip.Content>
  </HubertTooltip>
);

interface Props {
  label: string;
  /** Short muted clarification shown next to the label. */
  hint?: string;
  /** Longer explanation, revealed via the ⓘ badge. */
  info?: ReactNode;
  className?: string;
}

/** Caption for a slot-filling input, so every field reads as labelled rather than a bare box. */
const FieldLabel = ({ label, hint, info, className }: Props) => (
  <div className={clsx('flex flex-row items-center gap-1.5', className)}>
    <HubertLabel className="text-xs">{label}</HubertLabel>
    {hint ? <MutedText className="text-xs" text={hint} /> : null}
    {info ? <FieldInfo>{info}</FieldInfo> : null}
  </div>
);

export default FieldLabel;
